"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var S = _interopRequireWildcard(require("./styled"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ProgressBar = function ProgressBar(_ref) {
  var total = _ref.total,
      current = _ref.current; // Prevent divide by zero error

  if (total === 0) return null;
  var currentValue = Math.round(current / total * 100);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative',
      height: '30px',
      marginBottom: '15px',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/_react["default"].createElement(S.ProgressBar, null, "".concat(currentValue < 100 ? currentValue : 100, "% Complete")), /*#__PURE__*/_react["default"].createElement(S.ProgressBar, {
    style: {
      backgroundColor: currentValue >= 100 ? '#19C855' : '#338ce4',
      color: '#fff',
      clipPath: "polygon(0% 0%, ".concat(currentValue + (currentValue >= 100 ? 2 : 0), "% 0%, ").concat(currentValue - (currentValue >= 100 ? 0 : 2), "% 100%, 0% 100%)")
    }
  }, "".concat(currentValue < 100 ? currentValue : 100, "% Complete"), currentValue < 100 && /*#__PURE__*/_react["default"].createElement(S.ProgressBarAnimation, null)));
};

ProgressBar.propTypes = {
  total: _propTypes["default"].number.isRequired,
  current: _propTypes["default"].number.isRequired
};
var _default = ProgressBar;
exports["default"] = _default;